import PropTypes from "prop-types";

function TableCellBar({ value = "NA", cellType = "td", styles = {}, mainProps = {}, showSeperator = true, testLabel = null, likertScale = null, fillColor = "#4caf50", isMean = true }) {
    const { main: mainStyles = {} } = styles;

    const Component = cellType === "th" ? "th" : "td";
    const isHeader = cellType === "th";

    const separatorClass = isHeader ? "table-seperator-col table-seperator-head-height" : "table-seperator-grey table-seperator-row-height";

    const calculatePercentForMean = value === "NA" ? 0 : `${(parseInt(value) / parseInt(likertScale)) * 100}%`;
    const scoreWidth = isMean ? calculatePercentForMean : value;

    return (
        <Component
            {...mainProps}
            style={{ position: "relative", ...mainStyles }}
            scope={isHeader ? "col" : undefined}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                {showSeperator && <div className={separatorClass} />}
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#ffffff",
                        borderRadius: "4px",
                        overflow: "hidden",
                        position: "relative",
                        boxShadow: "rgba(0, 0, 0, 0.2) 2px 2px 5px",
                    }}
                >
                    <div
                        style={{
                            width: value === "NA" ? "100%" : scoreWidth,
                            height: "100%",
                            backgroundColor: value !== "NA" && fillColor,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            borderRadius: "0 4px 4px 0",
                        }}
                    >
                        <span
                            style={{
                                marginRight: value !== "NA" && parseInt(scoreWidth) < parseInt("80%") ? "-40px" : "40%" /* pushes text just outside color edge */,
                                fontSize: "12px",
                                color: "#000",
                                whiteSpace: "wrap",
                                // zIndex: 1,
                            }}
                        >
                            {value} <span style={{ fontWeight: 700 }}>&nbsp;&nbsp;{testLabel}</span>
                        </span>
                    </div>
                </div>
            </div>
        </Component>
    );
}

TableCellBar.propTypes = {
    value: PropTypes.node,
    testLabel: PropTypes.node,
    styles: PropTypes.shape({
        main: PropTypes.object,
        wrapper: PropTypes.object,
        value: PropTypes.object,
    }),
    mainProps: PropTypes.object,
    cellType: PropTypes.oneOf(["td", "th"]),
    showSeperator: PropTypes.bool,
    likertScale: PropTypes.number,
    fillColor: PropTypes.string,
    isMean: PropTypes.bool,
};

export default TableCellBar;
